import { DqLoader } from "@decentriq/components";
import { useMount } from "ahooks";
import isNil from "lodash/isNil";
import { memo } from "react";
import { type AudienceV3 } from "features/mediaDataRoom/models";
import { formatNumber } from "features/mediaDataRoom/utils";
import { useAudiences } from "features/mediaDataRoom/wrappers";

type AudienceV3SizeProps = AudienceV3;

const AudienceV3Size = memo<AudienceV3SizeProps>((audience) => {
  const {
    audienceSizes: { enableSizeEstimationForAudience, audienceSizes },
  } = useAudiences();
  useMount(() => {
    if (!audience.isStale) {
      enableSizeEstimationForAudience(audience.id);
    }
  });
  if (audience.errorReport) {
    return "—";
  }
  const sizeState = audienceSizes[audience.id];
  if (sizeState?.loading) {
    return <DqLoader size="xxs" />;
  }
  if (!isNil(sizeState?.audienceSize)) {
    return formatNumber(sizeState.audienceSize);
  }
  return "—";
});
AudienceV3Size.displayName = "AudienceV3Size";

export default AudienceV3Size;
